var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.896875 0 0 0.896875 0 2V12C0 13.1031 0.896875 14 2 14H14C15.1031 14 16 13.1031 16 12V5C16 3.89687 15.1031 3 14 3H2.5C2.225 3 2 2.775 2 2.5C2 2.225 2.225 2 2.5 2H14C14.5531 2 15 1.55313 15 1C15 0.446875 14.5531 0 14 0H2ZM13 7.5C13.2652 7.5 13.5196 7.60536 13.7071 7.79289C13.8946 7.98043 14 8.23478 14 8.5C14 8.76522 13.8946 9.01957 13.7071 9.20711C13.5196 9.39464 13.2652 9.5 13 9.5C12.7348 9.5 12.4804 9.39464 12.2929 9.20711C12.1054 9.01957 12 8.76522 12 8.5C12 8.23478 12.1054 7.98043 12.2929 7.79289C12.4804 7.60536 12.7348 7.5 13 7.5Z",
    fill: "#8B5CF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.082390bcab9e7d09d5b89533486cbe58.svg";
export { ForwardRef as ReactComponent };